//DNA
import useDecodeToken from "@/utils/hooks/useDecodeJwt";
import dataManagement from "@/navigation/data-management";
// import inventory from "@/navigation/inventory";
import privileges from "@/navigation/privileges";
import report from "@/navigation/report";
import banner from "@/navigation/banner";
import tags from "@/navigation/tags";
// import fulfillment from "@/navigation/fulfillment";
import document from "@/navigation/document";
import article from "@/navigation/article";
import survey from "@/navigation/survey";

//custom module Bay-Mini
import merchant from "@/constants/navigation/BUSDOAIGQZSP/menu/merchant";
import productMerchant from "@/constants/navigation/BUSDOAIGQZSP/menu/provider-merchant/product-merchant";
import product from "@/constants/navigation/BUSDOAIGQZSP/menu/product";
import order from "@/constants/navigation/BUSDOAIGQZSP/menu/order";
import inventory from "@/constants/navigation/BUSDOAIGQZSP/menu/inventory";
import fulfillment from "@/constants/navigation/BUSDOAIGQZSP/menu/fulfillment";
import dashboard from "@/constants/navigation/BUSDOAIGQZSP/menu/dashboard";
import dataManagementCustome from "@/constants/navigation/BUSDOAIGQZSP/menu/data-management";
import merchantReport from "@/constants/navigation/BUSDOAIGQZSP/menu/merchant-report";

const { decodeToken } = useDecodeToken();
const renderNavByPermission = () => {
  switch (decodeToken()?.provider_ref) {
    case "PVfwODwRBNnxxv": // Dev Bay-Mini BO EP Merchant
      return [
        ...merchant,
        ...productMerchant,
        ...order,
        ...inventory,
        ...fulfillment,
        ...dataManagementCustome,
        ...merchantReport,
      ];
    case "PVvFJHu91GtxDx": // Dev Bay-Mini BO EP  KA
      return [
        ...product,
        ...order,
        ...inventory,
        ...fulfillment,
        ...dashboard,
        ...article,
        ...banner,
        ...report,
      ];
    case "PVcvmBPdJ4nmri": // Dev Bay-Mini BO EP
      return [
        ...merchant,
        ...product,
        ...order,
        ...inventory,
        ...fulfillment,
        ...dashboard,
        ...article,
        ...banner,
        ...report,
      ];
    default:
      return [
        ...merchant,
        ...product,
        ...order,
        ...inventory,
        ...fulfillment,
        ...dashboard,
        ...article,
        ...banner,
        ...report,
      ];
  }
};

export default renderNavByPermission();
